// toastUtils.ts
import { toast } from 'react-toastify';
import { getApiErrorMessage } from './getApiErrorMessage';

export const showSuccessToast = (message: string) => {
    toast.success(message, {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        progressStyle: { background: '#4caf50' },
    });
};

export const showErrorToast = (message: any, fallback: string = 'An error occurred') => {
    const text = typeof message === 'string' && !message.includes('[object Object]')
        ? message
        : getApiErrorMessage(message, fallback);

    toast.error(text, {
        position: 'top-center',
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        progressStyle: { background: '#f44336' },
    });
};

export const showWarningToast = (message: any, fallback: string = 'Warning') => {
    const text = typeof message === 'string' && !message.includes('[object Object]')
        ? message
        : getApiErrorMessage(message, fallback);

    toast.warn(text, {
        position: 'top-center',
        autoClose: 3500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        progressStyle: { background: '#ff9800' }, // orange
    });
};